const SHORTCUT_BLOCKING_SELECTOR =
  'input,textarea,select,[contenteditable="true"],[role="combobox"],[role="listbox"],[role="option"],[role="spinbutton"],[role="textbox"]';

const isEditableElement = (element: Element | EventTarget | null): boolean => {
  if (!(element instanceof HTMLElement)) {
    return false;
  }

  if (element.isContentEditable) {
    return true;
  }

  const tagName = element.tagName;

  if (tagName === 'INPUT' || tagName === 'SELECT' || tagName === 'TEXTAREA') {
    return true;
  }

  return Boolean(element.closest(SHORTCUT_BLOCKING_SELECTOR));
};

export const shouldIgnoreSurveyKeyboardShortcut = (event: KeyboardEvent): boolean => {
  if (isEditableElement(event.target)) {
    return true;
  }

  return isEditableElement(document.activeElement);
};
